import React from 'react';
import './Badge.scss';

export type BadgeVariant = 'error' | 'warning' | 'success' | 'info' | 'neutral';

interface BadgeProps {
  variant?: BadgeVariant;
  children: React.ReactNode;
}

export const Badge: React.FC<BadgeProps> = ({ variant = 'neutral', children }) => (
  <span className={`ovp-badge ovp-badge--${variant}`}>{children}</span>
);
